export const asObject = <T extends object = Record<string, unknown>>(
  value: unknown
): T | undefined =>
  Boolean(value) && typeof value === "object" && !Array.isArray(value)
    ? (value as T)
    : undefined;

export const asArray = <T extends object = Record<string, unknown>>(
  value: unknown
): T[] =>
  Array.isArray(value)
    ? value
        .map((item) => asObject<T>(item))
        .filter((item): item is T => Boolean(item))
    : [];

export const asText = (value: unknown) =>
  typeof value === "string" && value.trim() ? value.trim() : undefined;

export const asNumber = (value: unknown) => {
  if (typeof value !== "number" && typeof value !== "string") return undefined;
  if (typeof value === "string" && !value.trim()) return undefined;

  const normalized =
    typeof value === "string" ? value.trim().replace(",", ".") : value;
  const number = Number(normalized);

  return Number.isFinite(number) ? number : undefined;
};

export const asId = (value: unknown) => {
  const number = asNumber(value);
  return number !== undefined && Number.isInteger(number) && number > 0
    ? number
    : undefined;
};

export const asBoolean = (value: unknown) =>
  value === true || value === 1 || value === "1" || value === "true";

export const firstText = (...values: unknown[]) => {
  for (const value of values) {
    const text = asText(value);
    if (text) return text;
  }

  return undefined;
};

export const firstPositiveNumber = (...values: unknown[]) => {
  for (const value of values) {
    const number = asNumber(value);
    if (number !== undefined && number > 0) return number;
  }

  return undefined;
};
